import { FC, ReactNode } from 'react';

import XUIDropdown, { XUIDropdownToggled } from '@xero/xui/react/dropdown';
import XUIIcon from '@xero/xui/react/icon';
import XUIButton from '@xero/xui/react/button';
import XUIDatePicker from '@xero/xui/react/datepicker';
import dateStartIcon from '@xero/xui-icon/icons/date-start';

import { middayOfTodayDate } from '../../helpers/date';

import './index.css';

interface IDropDownDatePickerProps {
    buttonContent: ReactNode;
    buttonLabel: ReactNode;
    onBlur?: () => void;
    selectedRange: { from: Date; to?: Date };
    setSelectedRange: (from: Date, to: Date | null) => void;
    pickerDateEnabledTo?: Date;
    isDisabled: boolean;
    maxEnabledDays: number;
    showValidationError?: boolean;
}

export const DropDownDatePicker: FC<IDropDownDatePickerProps> = (props) => {
    const { maxEnabledDays, showValidationError } = props;
    const minDate = (d1: Date, d2: Date) => {
        return d1 < d2 ? d1 : d2;
    };

    const maxDate = (d1: Date, d2: Date) => {
        return d1 > d2 ? d1 : d2;
    };

    const onSelectDate = (newDate: Date) => {
        return props.setSelectedRange(minDate(newDate, middayOfTodayDate()), maxDate(newDate, middayOfTodayDate()));
    };

    const isDateOutsideRange = (d1: Date, d2: Date, targetD: Date): boolean => targetD < d1 || targetD > d2;

    const datePickerEnabledFrom = middayOfTodayDate();
    datePickerEnabledFrom.setDate(datePickerEnabledFrom.getDate() - maxEnabledDays);

    const isDateDisabled = (dateInQuestion: Date): boolean => {
        return props.pickerDateEnabledTo !== undefined && datePickerEnabledFrom !== undefined
            ? isDateOutsideRange(datePickerEnabledFrom, props.pickerDateEnabledTo, dateInQuestion)
            : false;
    };

    const trigger = (
        <XUIButton
        className='icon-button'
        isDisabled={props.isDisabled}
        style={showValidationError ? { border: '1px solid red' } : {}}>
        <XUIIcon icon={dateStartIcon} className='calendar-icon' />
        {props.buttonContent}
        </XUIButton>
    );

    const selectionBox = (
        <XUIDropdown hasFixedWidth={true} className='search-box'>
            <XUIDatePicker
                isDateDisabled={isDateDisabled}
                onSelectDate={onSelectDate}
                selectedRange={props.selectedRange}
                locale='english'
                nextButtonAriaLabel='text'
                prevButtonAriaLabel='private'
                monthDropdownAriaLabel={'[Placeholder] Month'}
                yearDropdownAriaLabel={'[Placeholder] Year'}
            />
        </XUIDropdown>
    );
    return (
        <div className='drop-down-calendar'>
            <div className='xui-heading-separator xui-text-emphasis xui-margin-top-xlarge'>{props.buttonLabel}</div>
            <XUIDropdownToggled
                trigger={trigger}
                dropdown={selectionBox}
                matchTriggerWidth={true}
                onClose={props.onBlur}
            />
        </div>
    );
};
